module.exports = __webpack_public_path__ + "static/img/Tutorial sin texto Redpie4 (1)-24.d72d3c26.jpg";